var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.66667,42.66667) scale(0.66667,0.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,42h-20c-4.411,0 -8,-3.589 -8,-8v-20c0,-4.411 3.589,-8 8,-8h20c4.411,0 8,3.589 8,8v20c0,4.411 -3.589,8 -8,8z",
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.926,17.488l-6.512,6.512l6.511,6.511c0.044,-0.164 0.075,-0.333 0.075,-0.511v-12c0,-0.178 -0.031,-0.347 -0.074,-0.512zM26.688,23.899l7.824,-7.825c-0.165,-0.043 -0.334,-0.074 -0.512,-0.074h-20c-0.178,0 -0.347,0.031 -0.512,0.074l7.824,7.825c1.483,1.481 3.893,1.481 5.376,0zM24,27.009c-1.44,0 -2.873,-0.542 -3.99,-1.605l-6.522,6.522c0.165,0.043 0.334,0.074 0.512,0.074h20c0.178,0 0.347,-0.031 0.512,-0.074l-6.522,-6.522c-1.117,1.063 -2.55,1.605 -3.99,1.605zM12.074,17.488c-0.043,0.165 -0.074,0.334 -0.074,0.512v12c0,0.178 0.031,0.347 0.074,0.512l6.512,-6.512z",
    fill: "#ffffff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.0aa307a75f121d349573ed4e9fe3b657.svg";
export { ForwardRef as ReactComponent };